const ContactInfo = {
    contact_phone: ["+971507907682"],
    contact_email: "ah3676411@gmail.com",
    address: "Oby Property M.B25 Mussafah 15 Abu Dhabi, UAE",
    // Social media links - Update these with your actual social media profiles
    facebook: "#", // Replace with actual Facebook page URL
    twitter: "#", // Replace with actual Twitter profile URL
    linkedin: "#", // Replace with actual LinkedIn company page URL
    instagram: "#", // Replace with actual Instagram profile URL
    youtube: "#", // Replace with actual YouTube channel URL
}

export { ContactInfo }
